import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type FAQ = {
  question: string;
  answer: string;
};
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs: FAQ[] = [{
    question: 'Does this answer my phone or handle calls?',
    answer: 'No. Viridia is built specifically for online leads—Yelp messages, Meta lead forms, Google inquiries, and website submissions. When someone submits a quote request online, the system responds instantly and guides them to book. It does not answer phone calls.'
  }, {
    question: 'Do you manage my ads?',
    answer: "Ad management is a separate service—Viridia focuses on what happens after the lead comes in. We plug into the lead sources you're already paying for (Yelp, Meta, Google) and make sure every online lead gets an instant response, automated follow-up, and a clear path to book. If you're interested in ad management as well, ask us about it during your onboarding call."
  }, {
    question: "I'm not techy. Will this be hard to use?",
    answer: "Not at all. With the Growth plan, our team does the entire setup for you—we connect your Yelp, Meta, and Google channels, configure your booking flow, and walk you through the dashboard live. You don't need to touch any settings. Most clients are fully live within one 20-minute onboarding call."
  }, {
    question: 'How long does setup take?',
    answer: 'Starter plan: about 10–15 minutes with our self-guided setup. Growth plan: one 20-minute onboarding call where we do everything for you—connect channels, set up automations, and walk you through the system.'
  }, {
    question: 'Can I cancel anytime?',
    answer: "Yes. Month-to-month, no contracts, no penalties. If it's not working for you, cancel anytime. That said, one landscaping client was booking 3–5 extra estimates per week within a few months—most people stick around."
  }, {
    question: "What if I'm not running many ads yet?",
    answer: "Even if you're only getting a handful of leads per week, the system makes sure every one gets an instant, professional response—and it scales with you as you grow. Many contractors start small and expand as they see the ROI."
  }, {
    question: 'What tools does this replace?',
    answer: "Most clients cancel their separate scheduling tool (Calendly, Acuity), email marketing tool (Mailchimp, Constant Contact), standalone CRM, and invoicing app. Viridia handles lead response, booking, pipeline management, and invoicing in one place—so you stop paying for tools that don't talk to each other."
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-white-smoke py-16 md:py-24 px-4" data-id="element-63">
      <div className="max-w-4xl mx-auto" data-id="element-64">
        <div className="text-center mb-12" data-id="element-65">
          <h2 className="text-3xl md:text-5xl font-extrabold text-jet-black mb-4" data-id="element-66">
            Common Questions
          </h2>
        </div>

        <div className="space-y-3" data-id="element-67">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden border-2 border-transparent transition-colors" data-id="element-68">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" aria-expanded={openIndex === index} data-id="element-69">
                <span className="text-lg md:text-xl font-bold text-jet-black pr-4" data-id="element-70">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-viridia-green flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} strokeWidth={2.5} data-id="element-71" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-72">
                <div className="px-6 pb-6" data-id="element-73">
                  <p className="text-base md:text-lg text-graphite-gray leading-relaxed" data-id="element-74">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}